import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter, inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {Match} from '../../../../../../model/events/Match';
import {LoadingService} from '../../../../../../services/loading.service';
import {Subscription} from 'rxjs';
import {SocketFrontendService} from '../../../../../../services/socket-frontend.service';
import {StompSubscription} from '@stomp/stompjs';
import {SocketData} from '../../../../../../model/SocketData';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {MatchResultService} from '../../../../../../services/match-result.service';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {environment} from '../../../../../../../environments/environment';
import {
  EventMatchDetailsComponent,
  MATCH_DETAILS_TAB_INFO, MATCH_DETAILS_TAB_PERFORMANCES, MATCH_DETAILS_TAB_REPORT, MATCH_DETAILS_TAB_STATISTICS
} from '../../event-match-details/event-match-details.component';
import {MatchResultPipe} from '../../../../../../pipes/match-result.pipe';
import {
  DOMAIN_VALUE_CD_PHASE_MODE_KRATZER,
  DOMAIN_VALUE_CD_STATUS_MATCH_FINISH,
  DOMAIN_VALUE_CD_WRITER_NONE
} from '../../../../../../constants';
import {CommonMatchService} from '../../../../../shared/service/common-match.service';
import {Event} from '../../../../../../model/events/Event';
import {EventFrontendDataService} from '../../event-frontend-data.service';
import {EventHelper} from '../../../../../shared/event/event-helper';
import {ParticipantFilterService} from '../../../../../shared/service/participant-filter.service';
import {Participant} from '../../../../../../model/participants/Participant';
import {Table, TableModule} from 'primeng/table';
import {TooltipModule} from 'primeng/tooltip';
import {SetlegmodePipe} from '../../../../../../pipes/setlegmode.pipe';
import {RoundDatePipe} from '../../../../../../pipes/roundDate.pipe';
import {BadgeModule} from 'primeng/badge';
import {DatePipe, NgOptimizedImage, NgTemplateOutlet} from '@angular/common';
import {ParticipantShortPipe} from '../../../../../../pipes/participant-short.pipe';
import {ParticipantPipe} from '../../../../../../pipes/participant.pipe';
import {
  KratzerTeilnehmerComponent
} from '../../../../../backend/event/event-module/event-ergebnisse/kratzer-teilnehmer/kratzer-teilnehmer.component';
import {
  DateTimePresenterComponent
} from '../../../../../shared/common/date-time-presenter/date-time-presenter.component';
import {FrontendService} from '../../../../../../services/frontend.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FrontendTitleService} from '../../../../../../services/callback/frontend-title.service';
import {Button} from 'primeng/button';
import {RoutingHelper} from '../../../../../../helper/routing.helper';
import {
  DOMAIN_VALUE_STATUS_MATCH_OPEN,
  DOMAIN_VALUE_STATUS_MATCH_PAUSE
} from '../../../../../../../assets/domains/domains';
import {AveragePipe} from '../../../../../../pipes/average.pipe';
import {MatchreportService} from '../../../../../shared/service/matchreport.service';
import {MatchHelper} from '../../../../../../helper/match.helper';

@Component({
  selector: 'app-event-phase-matchlist',
  standalone: true,
  templateUrl: './event-phase-matchlist.component.html',
  styleUrls: ['./event-phase-matchlist.component.scss'],
  imports: [
    TableModule,
    TranslateModule,
    TooltipModule,
    SetlegmodePipe,
    RoundDatePipe,
    BadgeModule,
    DatePipe,
    ParticipantShortPipe,
    ParticipantPipe,
    MatchResultPipe,
    KratzerTeilnehmerComponent,
    DateTimePresenterComponent,
    NgOptimizedImage,
    Button,
    NgTemplateOutlet,
    AveragePipe
  ],
  animations: [
    trigger('successTrigger',
      [
        state('initial', style({
          /*backgroundColor: 'transparent',*/
        })),
        state('final', style({
          backgroundColor: '#00AA0066',
        })),
        transition('* => final', animate('200ms ease-in')),
        transition('final => *', animate('500ms ease-out'))
      ]
    )
  ]
})
export class EventPhaseMatchlistComponent implements OnInit, AfterViewInit, OnDestroy
{
  protected readonly DOMAIN_VALUE_STATUS_MATCH_OPEN = DOMAIN_VALUE_STATUS_MATCH_OPEN;
  protected readonly DOMAIN_VALUE_STATUS_MATCH_PAUSE = DOMAIN_VALUE_STATUS_MATCH_PAUSE;

  private router = inject(Router);
  private frontendTitleService = inject(FrontendTitleService);
  private route = inject(ActivatedRoute);

  @ViewChild('table') table: Table;

  private eventIdPrivate: number;

  @Input() set eventId(value: number)
  {
    this.eventIdPrivate = value;
    this.initSocket();
  }
  @Input() set event(value: Event)
  {
    this.initEvent(value);
    this.eventIdPrivate = value.id;
    this.initSocket();
  }
  @Input() databaseId: number;
  tableHeight = 200;

  eventIntern: Event;
  matches: Match[];
  resultsWidth: number;
  isMobile: boolean;
  rowView = false;
  isTeam: boolean;
  isLeague: boolean;
  showWriter = true;
  showDateIntern: boolean;
  @Input() disableSockets: boolean;
  liveViewPrivate: boolean;
  @Input() set liveView(value: boolean)
  {
    this.liveViewPrivate = value;
    this.initSocket();
  }
  @Input() mandantKey: number;
  @Input() scrollable = true;
  @Input() scrollToNextMatch = false;
  @Input() additionalHeight = 0;
  @Input() showDate = false;
  @Input() isEDart: boolean;
  isKratzer: boolean;
  @Input() showEvent = false;
  @Input() displayView = false;
  @Input() fontWhite = true;

  @Input() tableHeaderMatches = 'MATCHES';
  @Input() showMouseOver = false;
  @Input() showGameNr = true;
  @Input() grouping = false;
  @Input() groupRowsBy = 'round.id';
  @Input() showColumnRound = false;
  @Input() showColumnEvent = false;
  @Input() tableClass: string;
  @Input() showTime = false;
  @Input() sortEnabled = false;
  @Input() positionTop: number;
  @Input() roundId: number;
  @Input() parentMatch?: Match;

  showBoardIntern = true;
  showBoardProperty = true;
  @Input() set showBoard(value: boolean)
  {
    this.showBoardProperty = value;
    this.checkBoards();
  }

  @Input() set matchesList(value: Match[])
  {
    console.log('set matchesList', value);
    this.matches = value;

    this.showEvent = false;
    this.isKratzer = false;
    if (this.matches)
    {
      for (const match of this.matches)
      {
        this.commonMatchService.prepareMatch(match, undefined, true);
        if (match.phase?.modeCd === DOMAIN_VALUE_CD_PHASE_MODE_KRATZER)
          this.isKratzer = true;

        this.prepareMatch(match);
      }
    }

    this.checkResultsWidth();
    this.checkBoards();
    this.initWriter();
    console.log('isKratzer: ' + this.isKratzer + ', isEDart: ' + this.isEDart);
    this.matchesLoadedInitScrollbar();
    this.matchesLoaded();
  }
  @Input() loading: boolean;
  @Input() dataLoading: LoadingService;
  @Output() onReloadData = new EventEmitter<string>();

  matchDetailsRef: DynamicDialogRef;
  initialMatchId: number;

  socketConnectionSubscription: Subscription;
  socketMatchesSubscription: StompSubscription;
  socketPhasesSubscription: StompSubscription;
  socketSubscription: Subscription;
  socketSubscription2: Subscription;

  participantChangedSubscription: Subscription;

  constructor(private socketFrontendService: SocketFrontendService,
              public matchResultService: MatchResultService,
              private matchResultPipe: MatchResultPipe,
              private dialogService: DialogService,
              private eventFrontendDataService: EventFrontendDataService,
              private commonMatchService: CommonMatchService,
              private changeDetectorRef: ChangeDetectorRef,
              private participantFilterService: ParticipantFilterService,
              private translate: TranslateService)
  {
    this.initEvent(this.eventFrontendDataService.eventData);
  }

  ngOnInit(): void
  {
    this.onResize();

    this.participantChangedSubscription = this.participantFilterService.participantSelected.subscribe(
      (participant: Participant) => this.participantFilterChanged(participant));

    this.changeDetectorRef.detectChanges();

    this.initParameters();
  }

  ngAfterViewInit(): void
  {
    setTimeout(() =>
    {
      this.onResize();
      // this.matchesLoaded();
    }, 0);
    setTimeout(() =>
    {
      this.onResize();
      // this.matchesLoaded();
    }, 250);

    this.matchesLoaded();
  }

  ngOnDestroy(): void
  {
    this.socketSubscription?.unsubscribe();
    this.socketSubscription2?.unsubscribe();
    this.socketConnectionSubscription?.unsubscribe();
    this.socketMatchesSubscription?.unsubscribe();
    this.socketPhasesSubscription?.unsubscribe();

    this.participantChangedSubscription?.unsubscribe();
  }

  private initParameters(): void
  {
    this.initialMatchId = +RoutingHelper.getUrlParam(this.route, 'matchId');
    console.log('[EventPhaseMatchlistComponent] initialMatchId: ' + this.initialMatchId);
  }

  private initEvent(event: Event): void
  {
    if (event)
    {
      console.log('initEvent: ', event);
      this.eventIntern = event;
      this.isTeam = EventHelper.isTeam(event);
      this.isLeague = EventHelper.isLeague(event);
      this.isEDart = EventHelper.isEDart(event);
      this.databaseId = EventHelper.getDatabaseId(event);
    }
  }

  private initSocket(): void
  {
    console.log('initSocket(), disableSockets: ' + this.disableSockets + ', databaseId: ' + this.databaseId);
    if (this.disableSockets)
      return;

    if (this.liveViewPrivate && this.databaseId >= 0)
      this.socketFrontendService.connect(this.databaseId);

    if (!this.socketSubscription)
    {
      this.socketSubscription = this.socketFrontendService.onReceiveDataMatches.subscribe((socketData) =>
      {
        console.log('socketData', socketData);
        this.socketDataReceived(socketData);
      });
    }
    if (!this.socketSubscription2 && !this.liveViewPrivate)
    {
      this.socketSubscription2 = this.socketFrontendService.onReceiveDataPhases.subscribe((socketData) =>
      {
        console.log('socketData', socketData);
        this.socketDataReceived(socketData);
      });
    }

    this.connectToSocket();
    this.socketConnectionSubscription = this.socketFrontendService.connectionChanged.subscribe(
      () => this.connectToSocket());
  }

  private connectToSocket(): void
  {
    if (this.socketFrontendService.socketConnected)
    {
      console.log('connectToSocket, mandantKey: ' + this.mandantKey);
      if (this.liveViewPrivate)
      {
        if (!this.socketMatchesSubscription && this.mandantKey)
          this.socketMatchesSubscription = this.socketFrontendService.subscribeToMatchesMandant(this.mandantKey);
      }
      else
      {
        if (!this.socketMatchesSubscription)
          this.socketMatchesSubscription = this.socketFrontendService.subscribeToMatches(this.eventIdPrivate, null);
        if (!this.socketPhasesSubscription)
          this.socketPhasesSubscription = this.socketFrontendService.subscribeToPhases(this.eventIdPrivate);
      }
    }
  }

  public onResize(): void
  {
    const mobile = (window.innerWidth < environment.mobileSize);
    if (this.isMobile !== mobile)
    {
      this.isMobile = mobile;
      this.rowView = mobile;
      this.checkResultsWidth();
    }
    this.calculateTableHeight();
  }

  private checkResultsWidth(): void
  {
    let width = 30;
    if (!this.isMobile && this.matches)
    {
      for (const match of this.matches)
      {
        if (match.matchmode && (match.matchmode.setsBestOf > 1 || match.matchmode.setsTotal > 1))
        {
          width = 90;
        }
      }
    }
    this.resultsWidth = width;
  }

  private calculateTableHeight(): void
  {
    const divContainer = document.getElementById('divMatchlist');
    if (divContainer)
    {
      // console.log('divContainer: ', divContainer);
      const footerHeight = document.getElementById('frontend_footer')?.offsetHeight;
      const offsetParent: any = divContainer.offsetParent;
      const absoluteTop = divContainer.offsetTop + offsetParent.offsetTop + (footerHeight ?? 40);
      const positionTop = absoluteTop + 16;
      if (this.positionTop > 0)
        this.tableHeight = window.innerHeight - this.positionTop + this.additionalHeight;
      else this.tableHeight = window.innerHeight - positionTop + this.additionalHeight;
      // console.log('calculateTableHeight, tableHeight: ' + this.tableHeight);

      // this.tableHeight = window.innerHeight - LayoutHelper.getTopFromElement('divMatchlist', 206);
      // console.log('calculateTableHeight 2: ' + this.tableHeight);
    }
    else
    {
      this.tableHeight = window.innerHeight - 246;
      console.log('calculateTableHeight FIX: ' + this.tableHeight);
    }

    setTimeout(() =>
    {
      this.matchesLoadedInitScrollbar();
    }, 0);
  }

  mouseOver(participantId: number): void
  {
    if (this.showMouseOver && participantId)
    {
      const elements = document.getElementsByClassName('participant_' + participantId);
      for (let i = 0; i < elements.length; i++)
      {
        (elements.item(i) as HTMLElement).style.color = 'red';
      }
    }
  }

  mouseOut(participantId: number): void
  {
    if (this.showMouseOver && participantId)
    {
      const elements = document.getElementsByClassName('participant_' + participantId);
      for (let i = 0; i < elements.length; i++)
      {
        (elements.item(i) as HTMLElement).style.color = '';
      }
    }
  }

  private prepareMatch(match: Match): void
  {
    if (!this.showEvent && match.event?.mainEvent)
      this.showEvent = true;
  }

  private socketDataReceived(socketData: SocketData): void
  {
    if (socketData.socketList?.length > 0)
    {
      // Wenn eine gebündelte Socketnachricht vorliegt, dann nur diese verarbeiten
      console.log('Gebündelte Socketnachricht empfangen, Anzahl: ' + socketData.socketList.length);
      for (const sd of socketData.socketList)
        this.socketDataReceived(sd);
      return;
    }

    if (socketData.match?.id)
    {
      if (!this.socketFrontendService.isPhaseActive(socketData))
        return;

      let updated = false;
      for (const match of this.matches)
      {
        this.commonMatchService.prepareMatch(match, undefined, true);
        this.prepareMatch(match);

        if (match.id === socketData.match.id)
        {
          if (socketData.updated)
          {
            this.updateMatch(match, socketData.match);
            this.checkBoards();
            this.initWriter();
            updated = true;
          }
          else if (socketData.deleted || socketData.created)
          {
            if (this.onReloadData)
            {
              this.onReloadData.emit();
              return;
            }
          }
        }
      }

      this.checkResultsWidth();

      if (!updated)
      {
        // Spiel nicht in Liste gefunden
        if (this.onReloadData)
        {
          this.onReloadData.emit();
        }
      }
    }

    if (socketData.phase)
    {
      // Phase hat sich geändert (z.B. Status)
      if (socketData.updated)
      {
        this.onReloadData.emit();
      }
    }
  }

  private updateMatch(match: Match, matchNew: Match): void
  {
    this.commonMatchService.updateMatch(match, matchNew);

    if (matchNew.statusCd)
      match.statusCd = matchNew.statusCd;

    if (!match.participantHome)
    {
      match.participantHome = {id: -2}; // force reload
    }
    if (!match.participantGuest)
    {
      match.participantGuest = {id: -2}; // force reload
    }

    // force reload
    match.refresh = true;
    setTimeout(() => match.refresh = false, 0);
    if (this.matchDetailsRef)
    {
      const dialogRef = this.dialogService.dialogComponentRefMap.get(this.matchDetailsRef);
      const componentInstance = dialogRef.instance.componentRef.instance as EventMatchDetailsComponent;
      componentInstance.updateTitle();
    }
  }

  public onPerformancesClicked(event: any, match: Match): void
  {
    event.stopPropagation();
    this.matchSelected(match, MATCH_DETAILS_TAB_PERFORMANCES);
  }

  public onStatisticsClicked(event: any, match: Match): void
  {
    event.stopPropagation();
    this.matchSelected(match, MATCH_DETAILS_TAB_STATISTICS);
  }

  public matchSelected(match: Match, selectedTab: string): void
  {
    console.log('matchSelected', match);
    if (this.isLeague && (match.byeHome || match.byeAway))
      return; // Keine Details bei Spielfrei
    if (!selectedTab)
      selectedTab = MATCH_DETAILS_TAB_INFO;
    const selectedTabOverridden = (match.matchReport && selectedTab === MATCH_DETAILS_TAB_INFO) ? MATCH_DETAILS_TAB_REPORT : selectedTab;
    if (!match.event)
      match.event = this.eventIntern;
    // this.matchDetailsRef = this.dialogHelperService.showEventMatchDetailsDialog(match, selectedTabOverridden, this.databaseId);
    this.matchDetailsRef = EventMatchDetailsComponent.showDialog(this.dialogService, match, selectedTabOverridden,
      this.matchResultPipe, this.databaseId, this.translate);
    this.matchDetailsRef.onClose.subscribe(() =>
    {
      this.matchDetailsRef = undefined;
    });
  }

  private checkBoards(): void
  {
    let hasBoard = false;
    let hasDate = false;

    if (this.matches)
    {
      for (const match of this.matches)
      {
        if (match.board)
          hasBoard = true;

        if (match.datePlanned)
          hasDate = true;

        if (hasBoard && hasDate)
          break;
      }
    }

    if (this.parentMatch && MatchHelper.isStatusFinish(this.parentMatch))
      this.showBoardIntern = false;
    else if (this.showBoardProperty)
      this.showBoardIntern = hasBoard;
    else this.showBoardIntern = false;

    console.log('checkBoards, HasDate: ' + hasDate + ', showBoardIntern: ' + this.showBoardIntern, this.parentMatch);
    this.showDateIntern = hasDate;
  }

  private participantFilterChanged(participant: Participant): void
  {
    console.log('participantFilterChanged: ', participant);
    if (!this.matches)
      return;
    for (const match of this.matches)
    {
      if (match.finished || match.statusCd === 'FINISH')
        continue;

      if (match.participantHome?.id === participant.id || match.participantGuest?.id === participant.id ||
        match.writer?.id === participant.id)
      {
        this.scrollToAndHighlightMatch(match, true);
        return;
      }
    }
  }

  private scrollToAndHighlightMatch(match: Match, hightlight: boolean): void
  {
    console.log('scrollToMatch, GameNr: ' + match.gameNr);
    if (!this.table)
      return;

    const elementDiv = document.getElementById('divMatchId#' + match.id);
    console.log('elementDiv: ', elementDiv);
    if (elementDiv?.parentElement?.parentElement?.offsetTop)
    {
      const top = elementDiv.parentElement.parentElement.offsetTop;
      if (top >= 80)
        this.table.scrollTo({top: top - 80, behavior: 'smooth'}); // Header + Überschrift abziehen
    }
    if (hightlight)
      this.highlightMatch(match);
  }

  private highlightMatch(match: Match): void
  {
    console.log('highlightMatch, GameNr: ' + match.gameNr);
    match.highlight = true;
    setTimeout(() =>
    {
      match.highlight = false;
      this.participantFilterService.selectedItem = undefined;

      match.highlightOut = true;
      setTimeout(() =>
      {
        match.highlightOut = false;
      }, 500);
    }, 3500);
  }

  private matchesLoadedInitScrollbar(): void
  {
    // console.log('matchesLoaded, scrollToNextMatch: ' + this.scrollToNextMatch, this.table);
    if (this.scrollToNextMatch && this.table && this.matches?.length > 0)
    {
      for (let i = 0; i < this.matches.length; ++i)
      {
        const match = this.matches[i];
        if (match.statusCd !== DOMAIN_VALUE_CD_STATUS_MATCH_FINISH)
        {
          if (i > 0)
            this.scrollToAndHighlightMatch(match, false);
          return;
        }
      }
      console.log('Alle Spiele abgeschlossen, Scroll zum Tabellenende');
      this.table.scrollTo({top: 5000, behavior: 'smooth'});
    }
  }

  private matchesLoaded(): void
  {
    console.log('[EventPhaseMatchlistComponent.ts] matchesLoaded()');
    if (this.initialMatchId > 0)
    {
      for (const match of this.matches)
      {
        if (this.initialMatchId === match.id)
        {
          this.initialMatchId = undefined;
          this.matchSelected(match, undefined);
        }
      }
    }

    for (const match of this.matches)
    {
      if (match.matchReportBlock?.group)
        match.matchReportBlock.showGroupHeader = MatchreportService.showGroupHeader(match.matchReportBlock, this.matches);
    }
  }

  private initWriter(): void
  {
    let hasWriterModeSet = false;
    let hasWriter = false;
    if (this.matches)
    {
      for (const match of this.matches)
      {
        if (!hasWriterModeSet && match.phase?.writerCd !== DOMAIN_VALUE_CD_WRITER_NONE)
          hasWriterModeSet = true;
        if (match.writer?.id > 0)
          hasWriter = true;
      }
    }
    const showWriterNew = !this.isKratzer && !this.isEDart && hasWriterModeSet && hasWriter;
    if (showWriterNew !== this.showWriter)
    {
      this.showWriter = showWriterNew;
      console.log('ShowWriter geändert auf: ' + this.showWriter);
    }
  }

  public eventClicked(event: any, item: Event): void
  {
    console.log('eventClicked: ', item);
    if (item?.id > 0)
    {
      if (event)
      {
        event.stopPropagation();
        event.preventDefault();
      }
      const url = FrontendService.getFrontendEventUriWithDatabase(this.databaseId) + item.id;
      if (url.includes('undefined'))
        console.error('URL kann nicht geöffnet werden: ' + url);
      else
      {
        this.router.navigate([url]);
        this.frontendTitleService.changeContent(url);
      }
    }
  }
}
